import { Button } from './ui/button';

interface PageVersionSwitchProps {
    isNew: boolean;
    onSwitch: () => void;
}

export const PageVersionSwitch = ({ isNew, onSwitch }: PageVersionSwitchProps) => {
    const label = isNew ? 'View legacy page' : 'View new page';
    return (
        <div className="absolute top-0 left-1/2 z-20 -translate-x-1/2">
            <Button
                variant="outline2"
                size="sm"
                className="-translate-y-1/2 rounded-full bg-white shadow-sm transition-transform hover:translate-y-0 focus-visible:translate-y-0"
                onClick={onSwitch}
            >
                {label}
            </Button>
        </div>
    );
};
